export const ENTITY_DETAILS_TABS = {
    OVERVIEW: 'entityDetailsOverview',
    REQUIREMENT_TYPES: 'entityDetailsRequirementTypes',
    COLLATERALS: 'entityDetailsCollaterals',
    EVENTS: 'entityDetailsEvents',
} as const;

export type EntityDetailsTabId = typeof ENTITY_DETAILS_TABS[keyof typeof ENTITY_DETAILS_TABS];
